import { ReactNode } from 'react';
import Sidebar from './Sidebar';

interface LayoutProps {
    children: ReactNode;
}

export default function Layout({ children }: LayoutProps) {
    return (
        <div className="min-h-screen bg-[#F7F7F7] text-[#73879C]">
            <Sidebar />
            <main className="ml-[230px] min-h-screen">{children}</main>
        </div>
    );
}
